import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isFunction } from "lodash";

import { manualCreateForwardDraw } from "@services/administrativeApprovals";

export const useManualCreateForwardDraw = (
  options: Record<string, any> = {}
) => {
  const { onSuccess, ...restOptions } = options;
  const queryClient = useQueryClient();

  return useMutation(manualCreateForwardDraw, {
    onSuccess: (res) => {
      queryClient.invalidateQueries({
        queryKey: ["administrativeApprovals"],
      });

      if (isFunction(onSuccess)) {
        onSuccess(res);
      }
    },
    ...restOptions,
  });
};
